/* eslint-disable react/no-multi-comp */
import React, {useEffect, useState} from 'react'
import {useLocation, matchPath} from 'react-router'
import {Link as RouterLink} from 'react-router-dom'
import clsx from 'clsx'
import PropTypes from 'prop-types'
import {useSelector} from 'react-redux'
import {makeStyles} from '@material-ui/styles'
import {
  Drawer,
  Divider,
  Avatar,
  List,
  ListSubheader,
  Typography,
  Hidden,
  IconButton,
  Badge,
  Link,
  colors
} from '@material-ui/core'
import MoreIcon from '@material-ui/icons/MoreVert'
import NavItem from 'src/components/NavItem'
import navConfigLawyer from './navConfigLawyer'
import navConfig from './navConfig'

const useStyles = makeStyles((theme) => ({
  root: {
    height: 'calc(100vh - 108px)',
    display: 'flex',
    flexDirection: 'column',
  },
  drawer: {
    backgroundColor: '#262b42',
  },
  mobileDrawer: {
    width: 256,
  },
  desktopDrawer: {
    width: 256,
  },
  navigation: {
    overflow: 'auto',
    padding: theme.spacing(0, 2, 10, 2),
    flexGrow: 1
  },
  profile: {
    padding: theme.spacing(2),
    display: 'flex',
    alignItems: 'center'
  },
  badge: {
    boxShadow: `0 0 0 2px ${theme.palette.background.paper}`
  },
  badgeDot: {
    height: 9,
    minWidth: 9
  },
  onlineBadge: {
    backgroundColor: colors.green[600]
  },
  awayBadge: {
    backgroundColor: colors.orange[600]
  },
  busyBadge: {
    backgroundColor: colors.red[600]
  },
  offlineBadge: {
    backgroundColor: colors.grey[300]
  },
  avatar: {
    cursor: 'pointer',
    width: 40,
    height: 40
  },
  details: {
    marginLeft: theme.spacing(2)
  },
  moreButton: {
    marginLeft: 'auto',
    color: colors.blueGrey[200]
  },
  logo: {
    height: 108,
    width: 100,
    padding: theme.spacing(2)
  }
}))

function renderNavItems({items, subheader, key, ...rest}) {
  return (
    <List key={key}>
      {subheader && <ListSubheader style={{color: '#E0B563', fontWeight: 'bold'}} disableSticky>{subheader}</ListSubheader>}
      {/* eslint-disable-next-line react/prop-types */}
      {items.reduce(
        // eslint-disable-next-line no-use-before-define
        (acc, item) => reduceChildRoutes({acc, item, ...rest}),
        []
      )}
    </List>
  )
}

function reduceChildRoutes({acc, pathname, item, depth = 0}) {
  if (item.items) {
    const open = matchPath(pathname, {
      path: item.href,
      exact: false
    })

    acc.push(
      <NavItem
        depth={depth}
        icon={item.icon}
        key={item.href}
        label={item.label}
        open={Boolean(open)}
        title={item.title}
      >
        {renderNavItems({
          depth: depth + 1,
          pathname,
          items: item.items
        })}
      </NavItem>
    )
  } else {
    acc.push(
      <NavItem
        depth={depth}
        href={item.href}
        icon={item.icon}
        key={item.href}
        label={item.label}
        title={item.title}
      />
    )
  }

  return acc
}

function NavBar({
                  openMobile,
                  onMobileClose,
                  className,
                  ...rest
                }) {
  const classes = useStyles()
  const location = useLocation()
  const session = useSelector((state) => state.session)
  const [status, setStatus] = useState('online')

  const handleStatusToggle = () => {
    const statusSeq = {
      online: 'away',
      away: 'busy',
      busy: 'offline',
      offline: 'online'
    }

    setStatus((prevStatus) => statusSeq[prevStatus])
  }

  useEffect(() => {
    if (openMobile && onMobileClose) {
      onMobileClose()
    }

    // eslint-disable-next-line
  }, [location.pathname])

  const {user: {lawyer_id}} = useSelector((state) => state.session)
  let config = lawyer_id !== 0 ? navConfigLawyer : navConfig

  const content = (
    <div
      {...rest}
      className={clsx(classes.root, className)}
    >
      <nav className={classes.navigation}>
        {config.map((list) => renderNavItems({
          items: list.items,
          subheader: list.subheader,
          pathname: location.pathname,
          key: list.subheader
        }))}
      </nav>
    </div>
  )

  return (
    <>
      <Hidden lgUp>
        <Drawer
          anchor="left"
          classes={{
            paper: clsx(classes.mobileDrawer, classes.drawer)
          }}
          onClose={onMobileClose}
          open={openMobile}
          variant="temporary"
        >
          <img src={'/images/logo.png'} className={classes.logo}/>
          {content}
        </Drawer>
      </Hidden>
      <Hidden mdDown>
        <Drawer
          anchor="left"
          classes={{
            paper: clsx(classes.desktopDrawer, classes.drawer)
          }}
          open
          variant="persistent"
        >
          <img src={'/images/logo.png'} className={classes.logo}/>
          {content}
        </Drawer>
      </Hidden>
    </>
  )
}

NavBar.propTypes = {
  className: PropTypes.string,
  onMobileClose: PropTypes.func,
  openMobile: PropTypes.bool
}

export default NavBar
